import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { AppUiActions } from '../../../store/actions';
import * as fromRoot from '../../../store/reducers';
import * as Enum from '../../../dtos/enums';
import { TestTakerService } from '../../../services/test-taker.service';
import { TimerService } from '../../../services/timer.service';
import * as ErrorMessages from '../../../errors/constants';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'exit-screen',
    template: require('./exit-screen.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExitScreenComponent implements OnInit, OnDestroy {
    isVisibleSubscription: Subscription;
    isExitScreenVisible: boolean = false;
    errorMsg: string;
    description: string;
    exitCode: string = "";
    selectedReason: number = -1;
    btnConfirmDisabled: boolean = false;
    exitReasons = [];
    hasTestTakerInfo = false;
    validationErrors = {
        exitCode: false,
        reason: false,
        description: false
    };
    private readonly confirmedExitEventName: string = "tdp:confirmed-exit";

    constructor(
        private store: Store<fromRoot.State>,
        private testTakerService: TestTakerService,
        private timerService: TimerService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.isVisibleSubscription = this.store.select(fromRoot.getIsExitScreenVisible).subscribe(isVisible => {
            this.isExitScreenVisible = isVisible;
            if (this.testTakerService.testTakerInfo) {
                this.hasTestTakerInfo = true;
            }
            this.changeDetectorRef.markForCheck();
            if (this.isExitScreenVisible) {
                this.timerService.pauseTimer();
            } else {
                this.changeDetectorRef.detectChanges();
            }
        });
        this.exitReasons = [
            { name: "Program Failure", value: Enum.TestTakerActivityTypeEnum.ApplicationShutdownProgramFailure },
            { name: "Hardware Issue", value: Enum.TestTakerActivityTypeEnum.ApplicationShutdownHardwareIssue },
            { name: "End of Test", value: Enum.TestTakerActivityTypeEnum.ApplicationShutdownEndOfTest },
            { name: "Other", value: Enum.TestTakerActivityTypeEnum.ApplicationShutdownOther }
        ];
    }

    ngOnDestroy() {
        this.isVisibleSubscription.unsubscribe();
    }

    confirmExit() {
        if (this.hasTestTakerInfo) {
            this.errorMsg = this.validateForm();
            if (this.errorMsg.length == 0) {
                this.btnConfirmDisabled = true;
                this.testTakerService.saveTestTakerActivityWithoutCaching(this.selectedReason, null, this.description);
                setTimeout(() => {
                    this.sendConfirmedExitEventToSecureBrowser();
                }, 2000);
            }
            this.changeDetectorRef.detectChanges();
        } else {
            this.sendConfirmedExitEventToSecureBrowser();
        }
    }

    sendConfirmedExitEventToSecureBrowser() {
        if (this.testTakerService.testNavigation.isEndOfTest != true) {
            this.testTakerService.uploadTestTakerLog();
        }
        const event = new MessageEvent(this.confirmedExitEventName, {
            bubbles: true,
            cancelable: false,
            data: ""
        });
        document.dispatchEvent(event);
    }

    cancelExit() {
        this.timerService.unpauseTimer();
        this.store.dispatch(new AppUiActions.HideExitScreen());
        this.changeDetectorRef.markForCheck();
    }

    validateForm(): string {
        this.validationErrors = {
            exitCode: false,
            reason: false,
            description: false
        };
        let errorMsg = "";
        if (this.hasTestTakerInfo) {
            if (this.testTakerService.testTakerInfo.CtcCode != this.exitCode) {
                errorMsg = ErrorMessages.Exit_ExitCode;
                this.validationErrors.exitCode = true;
            } else {
                switch (this.selectedReason.toString()) {
                    case Enum.TestTakerActivityTypeEnum.ApplicationShutdownProgramFailure.toString():
                    case Enum.TestTakerActivityTypeEnum.ApplicationShutdownHardwareIssue.toString():
                    case Enum.TestTakerActivityTypeEnum.ApplicationShutdownOther.toString():
                        if (!this.description || this.description.length < 1) {
                            errorMsg = ErrorMessages.Exit_ExitDescription;
                            this.validationErrors.description = true;
                        }
                        break;
                    case Enum.TestTakerActivityTypeEnum.ApplicationShutdownEndOfTest.toString():
                        break;
                    default:
                        errorMsg = ErrorMessages.Exit_ExitReason;
                        this.validationErrors.reason = true;
                        break;
                }
            }
        }
        return errorMsg;
    }

    onFormUpdate() {
        this.errorMsg = "";
        this.validateForm();
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/exit-screen/exit-screen.component.ts